<div class="about-container">
    <div class="about">
        @for (homeInfo of homeInfoList; track homeInfo) {
            <div class="info-container">
                <div class="info">
                    <div [innerHTML]="homeInfo.value"></div>
                </div>
            </div>
        }
    </div>
</div>
